<template>
  <div v-if="$route.name == 'Stock'">
    <div class="space-between">
      <div class="mt-1">
        <a-typography-title :level="4">Stock colaboradores</a-typography-title>
      </div>
      <div style="display: flex">
        <a-button
          v-if="userRole !== 'rrhh'"
          class="ml-2"
          @click="openStockTable"
        >
          Historial stock
        </a-button>
        <a-button
          v-if="userRole === 'superadmin'"
          class="ml-2"
          @click="() => baja_stock_ref.openModal()"
        >
          Baja al stock
        </a-button>
        <a-button
          v-if="userRole === 'superadmin'"
          type="primary"
          class="ml-2"
          @click="() => alta_stock_ref.openModal()"
        >
          Alta al stock
        </a-button>
      </div>
    </div>

    <alta-stock-modal
      :insurance-companies="insurance_companies"
      ref="alta_stock_ref"
      @uploaded="getStockEmployeeCompanies"
    />

    <baja-stock-modal
      :insurance-companies="insurance_companies"
      ref="baja_stock_ref"
      @uploaded="getStockEmployeeCompanies"
    />

    <a-row justify="start" class="mt-1">
      <div></div>
      <div>
        <a-button
          class="button_with_icon"
          @click="showDownloadStockModal"
        >
          <template #icon>
            <download-outlined />
          </template>
          Descargar stock
        </a-button>
      </div>
    </a-row>

    <a-modal
      v-model:visible="downloadStockModal"
      title="Descargar stock de empleados"
      @ok="handleDownloadStock"
    >
      <a-typography-text class="d-block mb-2">Empresa</a-typography-text>
      <a-input :value="companyName" disabled class="mb-3" />

      <a-button
        :type="showAdvancedFilters ? 'primary' : 'default'"
        @click="showAdvancedFilters = !showAdvancedFilters"
      >
        {{
          showAdvancedFilters
            ? 'Ocultar filtros'
            : 'Agregar filtros (opcional)'
        }}
      </a-button>

      <div v-if="showAdvancedFilters" class="mt-3">
        <a-row align="middle" justify="space-between" class="mb-2">
          <a-col>
            <a-typography-text class="fw-semibold fs-6">
              Pólizas
            </a-typography-text>
          </a-col>
          <a-col>
            <a-checkbox-group v-model:value="policyStatusFilter">
              <a-checkbox value="Vigente">Vigentes</a-checkbox>
              <a-checkbox value="No vigente">No vigentes</a-checkbox>
            </a-checkbox-group>
          </a-col>
        </a-row>
        <a-select
          v-model:value="selectedPolicyIds"
          mode="multiple"
          :options="policyOptions"
          placeholder="Seleccionar pólizas"
          style="width: 100%"
        />
        <a-typography-text type="secondary" class="d-block mb-3">
          Vacío = todas las pólizas
        </a-typography-text>

        <a-typography-text class="d-block">Vigente al</a-typography-text>
        <a-date-picker
          v-model:value="activeDate"
          format="DD-MM-YYYY"
          placeholder="Selecciona una fecha"
          allow-clear
          style="width: 100%"
        />
        <a-typography-text type="secondary" class="d-block">
          Vacío = sin filtro de fecha
        </a-typography-text>
      </div>
    </a-modal>

    <a-table
      class="mt-2"
      :data-source="stock_data"
      :columns="columns"
      :pagination="pagination_props"
      :loading="loading_table"
      @change="changeCurrentPage"
      :scroll="{ x: 1000 }"
    >
      <!-- Filtro por busqueda normal -->
      <template #filterDropdown="{ column, confirm, clearFilters }">
        <div style="padding: 8px">
          <a-input
            v-model:value="filter_values[column.key]"
            :placeholder="`Buscar por ${column.title}`"
            @pressEnter="
              handleSearch(column.dataIndex, filter_values[column.key], confirm)
            "
            style="width: 188px; margin-bottom: 8px; display: block"
          />
          <a-button
            type="primary"
            size="small"
            style="width: 90px; margin-right: 8px"
            @click="
              handleSearch(column.dataIndex, filter_values[column.key], confirm)
            "
          >
            <template #icon><search-outlined /></template>
            Buscar
          </a-button>
          <a-button
            size="small"
            style="width: 90px"
            @click="handleColumnReset(column.dataIndex, clearFilters)"
          >
            Limpiar
          </a-button>
        </div>
      </template>

      <!-- Icono de filtrado de lupa -->
      <template #filterIcon="{ column }">
        <search-outlined
          :style="{
            color:
              search_value[column.dataIndex] === undefined ||
              search_value[column.dataIndex] === ''
                ? undefined
                : '#2521E5'
          }"
        />
      </template>
      <!-- Renderizado para el click de ver más -->
      <template #renderDetails="{ text }">
        <a-tooltip color="#05045D" :title="`Ver más`">
          <router-link
            :to="{ name: 'Colaborador', params: { colaborador: text } }"
          >
            <eye-outlined class="blue-icon" />
          </router-link>
        </a-tooltip>
        <!-- <router-link :to="{name:'Colaborador', params: {colaborador:text}}">
          Ver más
        </router-link> -->
      </template>
    </a-table>
  </div>
  <router-view :key="$route.path"></router-view>
  <TableStockDetails ref="tableDetailsRef" />
</template>

<script>
import {
  SearchOutlined,
  EyeOutlined,
  DownloadOutlined
} from '@ant-design/icons-vue';
import { useRoute, useRouter } from 'vue-router';
import { useStore } from 'vuex';
import { computed, onMounted, reactive, ref, watch } from 'vue';
import openNotificacion from '@/utils/notifications';
import rutHelper from '@/utils/Ruts';
import AltaStockModal from '@/components/stock/incorporation-stock-modal.vue';
import BajaStockModal from '@/components/stock/exclusion-stock-modal.vue';
import TableStockDetails from '@/components/stock/stock-files-table.vue';
import notification from '@/utils/notifications';
import {
  FETCH_STOCK_EMPLOYEE_COMPANIES,
  FETCH_INSURANCE_COMPANY,
  GET_LOGGED_USER,
  GET_DATA_STOCK,
  GETTER_STOCK_TABLE_TOTAL_PAGES,
  GETTER_STOCK_TABLE_ITEMS_PER_PAGE,
  GETTER_STOCK_TABLE_CURRENT_PAGE,
  GET_INSURANCE_COMPANY,
  DOWNLOAD_EXCEL_STOCK,
  GET_COMPANY
} from '@/store/types';
import {
  FETCH_COMPANY_POLICIES,
  GET_COMPANY_POLICIES
} from '@/store/clients/policies/types';
import { validateToken } from '@/network/interceptors/validateToken';
import parseDate from '@/utils/dateFormatter';
import getTagColor from '@/utils/getTagColor';
import getTagText from '@/utils/getTagText';

export default {
  name: 'Stock',
  components: {
    'search-outlined': SearchOutlined,
    'eye-outlined': EyeOutlined,
    'download-outlined': DownloadOutlined,
    AltaStockModal,
    BajaStockModal,
    TableStockDetails
  },
  setup() {
    // * Iniciacion de variables
    const route = useRoute();
    const router = useRouter();
    const store = useStore();
    const userRole = store.getters[GET_LOGGED_USER].roleName;

    const company_id = computed(() => route.params.id);

    // * Obtencion de data
    watch(
      () => route.fullPath,
      () => {
        if (route.name == 'Stock') {
          getStockEmployeeCompanies();
        }
      },
      { deep: true }
    );

    const loading_table = ref(false);
    const getStockEmployeeCompanies = async () => {
      loading_table.value = true;
      await store
        .dispatch(FETCH_STOCK_EMPLOYEE_COMPANIES, {
          companyId: company_id.value,
          query: {
            ...route.query,
            ...(route?.query?.rut
              ? { rut: rutHelper.normalizeRut(route?.query?.rut) }
              : {})
          }
        })
        .catch((error) => {
          openNotificacion('error', 'Error', error.response.data.message);
        })
        .finally(() => {
          loading_table.value = false;
        });
    };

    // * Tabla
    const filter_values = ref({}); // Objeto que guarda los valores que voy filtrando por v-model
    const search_value = ref({}); // Objeto que guarda los valores de los cuales se hace la busqueda por filtro

    const stock_data = computed(() => {
      return store.getters[GET_DATA_STOCK].map((e) => ({
        id: e.id,
        key: e.id,
        name: e.fullname,
        rut: rutHelper.formatRut(e.rut),
        groupName: e?.groupCompanyNames,
        type: 'stockColaborador'
      }));
    });

    const columns = [
      {
        title: 'Nombre',
        dataIndex: 'name',
        key: 'name',
        slots: {
          filterDropdown: 'filterDropdown',
          filterIcon: 'filterIcon'
        }
      },
      {
        title: 'RUT',
        dataIndex: 'rut',
        key: 'rut',
        slots: {
          filterDropdown: 'filterDropdown',
          filterIcon: 'filterIcon'
        }
      },
      {
        title: 'Grupos',
        dataIndex: 'groupName',
        key: 'groupName',
        slots: {
          filterDropdown: 'filterDropdown',
          filterIcon: 'filterIcon'
        }
      },
      {
        title: 'Acción',
        dataIndex: 'id',
        key: 'id',
        slots: {
          customRender: 'renderDetails'
        }
      }
    ];

    // PAGINACION
    // Total de paginas
    const total = computed(() => {
      return store.getters[GETTER_STOCK_TABLE_TOTAL_PAGES];
    });
    // Items por página
    const items_per_page = computed(() => {
      return store.getters[GETTER_STOCK_TABLE_ITEMS_PER_PAGE];
    });

    // Pagina en la que nos encontramos
    const current_page = computed(() => {
      return store.getters[GETTER_STOCK_TABLE_CURRENT_PAGE];
    });

    const pagination_props = reactive({
      total,
      pageSize: items_per_page,
      current: current_page
    });

    // color del tag dependiendo del estado del ticket
    const getTagColorByState = (state) => {
      return getTagColor(state);
    };

    // Agregar el nuevo valor del filtro
    const filterRedirectionNewParam = (key, param) => {
      search_value.value[key] = param;

      if (key != 'page') {
        search_value.value['page'] = 1;
      }

      router.replace({
        name: 'Stock',
        query: search_value.value
      });
    };

    // Busqueda por columna
    const handleSearch = (column, value, confirm) => {
      if (value != '') {
        if (column == 'rut') {
          filterRedirectionNewParam(column, rutHelper.formatRut(value));
        } else {
          filterRedirectionNewParam(column, value);
        }
        confirm();
      }
    };

    // Limpiar columna
    const handleColumnReset = (column, resetConfirm) => {
      delete filter_values.value[column];
      delete search_value.value[column];

      router.replace({
        name: 'Stock',
        query: search_value.value
      });

      resetConfirm();
    };

    const changeCurrentPage = (page) => {
      filterRedirectionNewParam('page', page.current);
    };

    // * Obtengo la lista de compañias aseguradoras
    const insurance_companies = computed(
      () => store.getters[GET_INSURANCE_COMPANY]
    );

    // * Alta stock
    const alta_stock_ref = ref();

    // * Baja stock
    const baja_stock_ref = ref();

    // * Descarga de stock
    const downloadStockModal = ref(false);
    const showDownloadStockModal = () => {
      downloadStockModal.value = true;
    };

    const companyName = computed(
      () => store.getters[GET_COMPANY]?.businessName || ''
    );

    const showAdvancedFilters = ref(false);
    const selectedPolicyIds = ref([]);
    const activeDate = ref(null);
    const policyStatusFilter = ref(['Vigente', 'No vigente']);

    const policyOptions = computed(() =>
      store.getters[GET_COMPANY_POLICIES]
        .filter((policy) => policyStatusFilter.value.includes(policy.status))
        .map((policy) => ({
          label: `${policy.policyNumber} (${policy.status})`,
          value: policy.id
        }))
    );

    const handleDownloadStock = async () => {
      if (!company_id.value) {
        notification('error', 'Error', 'No se pudo determinar la empresa.');
        return;
      }

      const isValid = await validateToken();
      if (!isValid) {
        router.push({ name: 'Login' });
        return;
      }

      const url = await store.dispatch(DOWNLOAD_EXCEL_STOCK, {
        companyId: company_id.value,
        policyIds: selectedPolicyIds.value.length
          ? selectedPolicyIds.value
          : undefined,
        activeDate: activeDate.value
          ? activeDate.value.format('YYYY-MM-DD')
          : undefined
      });

      const cacheBustedUrl =
        `${url}${url.includes('?') ? '&' : '?'}` + `_ts=${Date.now()}`;

      window.open(cacheBustedUrl, '_blank');
      downloadStockModal.value = false;
    };
    const getInsuranceCompany = async () => {
      try {
        await store.dispatch(FETCH_INSURANCE_COMPANY, {
          companyId: company_id.value
        });
      } catch (error) {
        notification(
          'error',
          'Error',
          error?.response?.data?.message || error.message
        );
      }
    };

    const tableDetailsRef = ref();

    const openStockTable = () => {
      tableDetailsRef.value.openModal();
    };

    // * Al momento de cargar la pagina y existan filtros anteriormente hechos, los agrego a la logica
    onMounted(async () => {
      const keys = Object.keys(route.query);

      keys.forEach((element) => {
        switch (element) {
          default: // Le paso valor al los inputs para que muestre que es lo que busco anteriormente
            filter_values.value[element] = route.query[element];
            break;
        }

        search_value.value[element] = route.query[element]; // Le paso valor al objeto de la busqueda en caso de hacer otra consulta
      });

      // Luego de pasar por esta logica, vamos obtener la lista de insurance company
      await getStockEmployeeCompanies();
      await getInsuranceCompany();
      store.dispatch(FETCH_COMPANY_POLICIES, `?companyId=${company_id.value}`);
    });

    return {
      stock_data,
      columns,
      filter_values,
      search_value,
      handleSearch,
      handleColumnReset,
      parseDate,
      getTagColorByState,
      pagination_props,
      loading_table,
      changeCurrentPage,
      userRole,
      insurance_companies,
      downloadStockModal,
      showDownloadStockModal,
      companyName,
      showAdvancedFilters,
      selectedPolicyIds,
      activeDate,
      policyStatusFilter,
      policyOptions,
      handleDownloadStock,
      getTagText,
      alta_stock_ref,
      baja_stock_ref,
      getStockEmployeeCompanies,
      tableDetailsRef,
      openStockTable
    };
  }
};
</script>

<style>
.space-between {
  display: flex;
  justify-content: space-between;
}
</style>
